<template>
    <b-form @submit.prevent="createCompany">
        <b-row>
            <b-col sm="12">
                <b-form-group :label="$t('register.companyNameLabel')" class="text-left label">
                    <b-form-input type="text" :placeholder="$t('register.companyNamePlaceholder')" class="input" required
                        v-model="company.company_name"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="12 mb-3">
                <v-app>
                    <v-tooltip bottom>
                        <template #activator="{ on, attrs }">
                            <label class="text-left w-fit-content" v-on="on" v-bind="attrs">{{ $t('register.compIdLabel') }}</label>
                        </template> {{ $t('register.compIdTooltip') }}
                    </v-tooltip>
                </v-app>
                <b-form-input type="text" :placeholder="$t('register.compIdPlaceholder')" class="input" required
                    v-model="company.company_id"></b-form-input>
                <p v-if="errors && errors.company_id" class="field-error text-left mb-4">
                    {{ errors.company_id[0] }}
                </p>
            </b-col>
            <b-col sm="12" v-if="canCreateOwnerOperatorCompany">
                <b-form-group :label="$t('register.companyTypeLabel')" class="text-left label">
                    <b-form-select class="input f-14" v-model="company.company_type" required>
                        <option value="">{{ $t('register.selectCompanyType') }}</option>
                        <option value="2">{{ $t('register.fleetOption') }}</option>
                        <option value="1">{{ $t('register.ownerOperatorOption') }}</option>
                    </b-form-select>
                </b-form-group>
            </b-col>
             <b-col sm="12" v-if="company.company_type === '2'">
                <b-form-group :label="$t('register.noOfDriversLabel')" class="text-left label">
                    <b-form-input type="number" :placeholder="$t('register.noOfDriversPlaceholder')" class="input" required
                        v-model="company.expected_no_of_drivers"></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <!-- <b-form-group label="Address:" label-for="input-1" class="mt-3 text-left label text-capitalize">
            <b-form-input type="text" class="mb-3 input" placeholder="Enter Address" v-model="company.address"
                required></b-form-input>
        </b-form-group>

        <b-form-group label="City:" label-for="input-1" class="text-left label text-capitalize">
            <b-form-input type="text" class="mb-3 input" placeholder="Enter City" v-model="company.city"
                required></b-form-input>
        </b-form-group>
        <b-form-group label="State:" label-for="input-1" class="text-left label text-capitalize">
            <v-select class="bg_white w-100" :options="states" item-value="id" item-text="label"
                :reduce="(option) => option.id" v-model="company.state">
                <template #search="{ attributes, events }">
                    <input class="vs__search" :required="!company.state" v-bind="attributes" v-on="events" />
                </template>
            </v-select>
        </b-form-group>
        <b-form-group label="Postal Code:" label-for="input-1" class="text-left label text-capitalize">
            <b-form-input type="text" class="mb-3 input" placeholder="Enter Postal Code" v-model="company.zipcode"
                required></b-form-input>
        </b-form-group>
        <b-form-group label="Phone Number:" label-for="input-1" class="text-left label text-capitalize">
            <b-input-group size="lg" class="w-100" prepend="+1">
                <b-form-input v-mask="phoneMask" class="f-14" v-model="company.phone_number" required></b-form-input>
            </b-input-group>
        </b-form-group> -->
        <b-button type="submit" class="w-100 mt-3 login h-40px" variant="primary">{{ $t('register.register') }}</b-button>
    </b-form>
</template>
<script>
export default {
    name: "Step2",
    props: ['company', 'createUserCompany', 'canCreateOwnerOperatorCompany'],
    data() {
        return {
            states: [],
            countries: [],
            errors: {},
        }
    },
    methods: {
        createCompany() {
            try {
                const regex = /^[A-Za-z0-9_-]{3,}$/;
                const isCompanyIDValid = regex.test(this.company.company_id);
                if (isCompanyIDValid) {
                    this.createUserCompany()
                    this.errors = {}
                }
                else {
                    let error = {};
                    error['company_id'] = [this.$t('register.companyIdValidation')];
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                }
            }
        },

    },
}
</script>